import { Box, Flex, Text } from '@chakra-ui/react';
import { ButtonText, OutlineCard } from '@morressier/alembic';
import EditAffiliationDetailsModal from './EditAffiliationDetailsModal';
import { IAffiliationDetails } from '@publishing-engine/domain/models';
import RinggoldBadge from '../RinggoldBadge';

type AffiliationDetailData = Partial<IAffiliationDetails>;

export const handleOpenUrl = (url: string) => {
  const urlWithProtocol = url.match(/^https?:\/\//) ? url : `https://${url}`;

  window.open(urlWithProtocol, '_blank', 'noopener,noreferrer');
};

export const AffiliationDetail = ({
  affiliation
}: {
  affiliation: AffiliationDetailData;
}) => (
  <OutlineCard width="100%" padding={4}>
    <Text textStyle="headingItem">
      {affiliation?.ringgoldId && <RinggoldBadge />}{' '}
      {affiliation.organizationName}
    </Text>
    <Flex direction={'column'}>
      <Text textStyle="textBody">{affiliation?.department || ''}</Text>

      <Text textStyle="textBody">
        {affiliation?.streetAddress ? affiliation?.streetAddress + ', ' : ''}
        {affiliation?.stateOrRegion || ''}
      </Text>
      <Text textStyle="textBody">
        {affiliation?.city || ''}
        {affiliation?.postalCode ? `- ${affiliation?.postalCode}` : ''}
      </Text>
      <Text textStyle="textBody">
        {affiliation?.country || ''}{' '}
        {affiliation?.countryCode && `(${affiliation?.countryCode})`}
      </Text>
      {affiliation.url?.trim() && (
        <Box>
          <ButtonText
            onClick={() => handleOpenUrl(affiliation.url || '')}
            whiteSpace="normal"
            wordBreak="break-all"
          >
            {affiliation.url}
          </ButtonText>
        </Box>
      )}
    </Flex>
  </OutlineCard>
);

const UpdateAffiliationDetails = ({
  affiliation,
  organizationId
}: {
  affiliation: IAffiliationDetails;
  organizationId: string;
}) => {
  return (
    <Flex direction="column" width="100%" gap={3}>
      <Flex align={'center'} justifyContent={'space-between'}>
        <Text textStyle="headingGroup">Primary Affiliation</Text>
        <EditAffiliationDetailsModal
          affiliation={affiliation}
          organizationId={organizationId}
        />
      </Flex>
      {affiliation && affiliation.organizationName ? (
        <AffiliationDetail affiliation={affiliation} />
      ) : (
        <OutlineCard width="100%" padding={4}>
          <Text textStyle="textBody" color="GrayText">
            No data available
          </Text>
        </OutlineCard>
      )}
    </Flex>
  );
};

export default UpdateAffiliationDetails;
